import * as Sentry from "@sentry/react";
import { sentryDsn } from "./constants/constants";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";

export const PERFORMANCE_METRICS = "performance-metrics";

// eslint-disable-next-line no-constant-condition
if (process.env.NODE_ENV === "production") {
  console.log(`Setting up LogRocket, env: ${process.env.NODE_ENV}`);
  // set up LogRocket before Sentry to allow sharing session URL
  LogRocket.init("0avtg0/flight", {
    rootHostname: "raven.ai", // connect flight & bifrost sessions
  });
  setupLogRocketReact(LogRocket);
  console.log(
    `Setting up error reporting service, env: ${process.env.NODE_ENV}`
  );
  const release = `flight@${process.env.REACT_APP_VERSION}`;
  Sentry.init({
    dsn: sentryDsn,
    release,

    // tracing
    integrations: [Sentry.browserTracingIntegration()],

    // --- Traces Sample Rate ---

    // Google Analytics https://analytics.google.com/analytics/web/
    // says we have ~8K sessions/month, avg 32 pageviews / session = 256K pageviews/mo

    // Seems like right now we send ~4 trace events per pageview

    // Sentry traces pricing: https://sentry.io/pricing/
    // -> 100K traces/mo free = ~25K pageviews/mo
    // 25K / 256K = ~0.1
    // -> 250K traces/mo $14 = ~125K pageviews/mo
    // 125K / 256K = ~0.5

    // so, starting this out at 0.08 to aim for <100K traces
    // production:

    // custom sample rate per transaction
    // tracesSampler: samplingContext =>
    //   samplingContext.transactionContext.name === PERFORMANCE_METRICS ? 1 : 0.08

    // static sample rate
    tracesSampleRate: 0.0, // ! deactivated for now since it hasn't been providing any value; we use Honeycomb instead

    // development:
    // tracesSampleRate: 1

    // * investigate sentryReduxEnhancer https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/redux/
    // * investigate Sentry.withProfiler for instrumenting components with react.mount, react.render, react.update events https://docs.sentry.io/platforms/javascript/guides/react/components/profiler/
  });

  LogRocket.getSessionURL(sessionURL => {
    Sentry.setExtra("sessionURL", sessionURL);
  });

  console.log(`Flight release: ${release}`);
} else {
  console.log(
    `Skip setting up error reporting service, env: ${process.env.NODE_ENV}`
  );
}
